import { axiosInstanceDPE } from './axiosInstance';
import { DpeInfo } from '../types';

interface AdressRequestDto {
  adresse: string;
  numeroVoie: string;
  nomRue: string;
  nomCommune: string;
  codePostal: string;
}

interface CallHectorRequestDto {
  nom: string;
  prenom: string;
  mail: string;
  adresse: string;
  numeroVoie: string;
  nomRue: string;
  nomCommune: string;
  codePostal: string;
  numeroDpe: string;
  telephone: string;
  professionalContact: string;
  legalTermsAccepted: string;
  leadGenerationID: string;
}

export const verifyListDPE = async (
  adresse: string,
  numeroVoie: string,
  nomRue: string,
  nomCommune: string,
  codePostal: string
): Promise<DpeInfo[]> => {
  const requestBody: AdressRequestDto = {
    adresse: adresse,
    numeroVoie: numeroVoie,
    nomRue: nomRue,
    nomCommune: nomCommune,
    codePostal: codePostal
  };

  try {
    const response = await axiosInstanceDPE.post('/dpe/residentiel/searchbyadress', requestBody);
    return response.data.data || [];
  } catch (error) {
    console.error('Erreur lors de la récupération des DPE:', error);
    return [];
  }
};

export const callHector = async (
  nom: string,
  prenom: string,
  mail: string,
  adresse: string,
  numeroVoie: string,
  nomRue: string,
  nomCommune: string,
  codePostal: string,
  numeroDpe: string,
  telephone: string,
  professionalContact: string,
  legalTermsAccepted: string,
  leadGenerationID: string
): Promise<{ success: boolean; message: string }> => {
  const requestBody: CallHectorRequestDto = {
    nom: nom,
    prenom: prenom,
    mail: mail,
    adresse: adresse,
    numeroVoie: numeroVoie,
    nomRue: nomRue,
    nomCommune: nomCommune,
    codePostal: codePostal,
    numeroDpe: numeroDpe,
    telephone: telephone,
    professionalContact: professionalContact,
    legalTermsAccepted: legalTermsAccepted,
    leadGenerationID: leadGenerationID
  };

  try {
    const response = await axiosInstanceDPE.post('/callhector', requestBody);
    return {
      success: true,
      message: response.data || "L'appel a été envoyé !"
    };
  } catch (error) {
    console.error('Erreur lors de l\'envoi de l\'appel Hector:', error);
    return {
      success: false,
      message: "Erreur lors de l'envoi de l'appel"
    };
  }
};
